// V2 has NO `/menu` endpoint. Build the same `{ page, children, depth }` tree the
// nav components expect, client-side from the flat CMS pages list (parent = int
// page id, sort_index for order). Returns `{ data: tree }` so callers that read
// `res.data` keep working unchanged.
export default function (axios) {
  return {
    async getMenu(config = {}) {
      const params = (config && config.params) || config || {}
      const res = await axios.get('/public-new/cms/pages', {
        params: { account_id: params.account_id, ...params },
      })
      const pages = (res && res.data && (res.data.results || res.data)) || []

      const byId = new Map()
      const nodes = pages
        .filter((p) => !p.hide_from_menu)
        .map((p) => ({ page: p, children: [], depth: 0 }))
      nodes.forEach((n) => byId.set(n.page.id, n))

      const roots = []
      nodes.forEach((n) => {
        const parentId = n.page.parent
        const parent = parentId && byId.get(parentId)
        if (parent) parent.children.push(n)
        else roots.push(n)
      })

      const setDepth = (n, d) => {
        n.depth = d
        n.children.forEach((c) => setDepth(c, d + 1))
      }
      roots.forEach((r) => setDepth(r, 0))

      return { data: roots }
    },
  }
}
